// extracted by css-extract-rspack-plugin
export default {"chart":"OgenW","chartGridContainer":"xfkRA","chartGrid":"QsjTU","warnings":"qna_m","commentsSidebar":"g_Sny","commentBadge":"o2rwz","commentTagArrow":"UaNtv"};